// Constants
import constants from '../constants'
import { goodflipImgUrls } from './goodflip-constants'

export const GOODFLIP_CONFIG = {
  id: constants.CARE_PROGRAM_TYPE.GOODFLIP,
  name: 'GoodFlip Health Program',
  drug_name: 'GoodFlip',
  campaign_link: `${process.env.REACT_APP_FE_URL}/onboarding`,
  medical_condition_group_id: null,
  upload_report_type: null,
  onboarding_steps: [],
  success_title: 'Registration completed successfully',
  showMetabolicScore: false,
  success_image: goodflipImgUrls.successImage,
  success_image_width: '100%',
}
